import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const PlayerImage = ({ answer} ) => {
  const { t } = useTranslation();
  return (
    <div className='o-player-cell o-player-cell__image'>
      { answer ?
        <img alt='Uploaded Answer' src={answer.imageUrl}/> :
        <span>{t('player.noImage')}</span> }
    </div>
  );
}

PlayerImage.propTypes = {
  responseType: PropTypes.object.isRequired,
  answer: PropTypes.object,
}

export default PlayerImage;
